import { render, staticRenderFns } from "./ClassName.vue?vue&type=template&id=e4fdb1a0&scoped=true&lang=pug&"
import script from "./ClassName.vue?vue&type=script&lang=ts&"
export * from "./ClassName.vue?vue&type=script&lang=ts&"
import style0 from "./ClassName.vue?vue&type=style&index=0&id=e4fdb1a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fdb1a0",
  null
  
)

export default component.exports